export default function Configure($stateProvider) {
    $stateProvider.state('modelessaisiese', {
        parent: 'common',
        url: '/modelessaisiese',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.ENVIRONNEMENT" | translate }}'
        }
    });

    $stateProvider.state('modelessaisiese.list', {
        url: '/list',
        template: '<modeles-saisies></modeles-saisies>',
        rights: { domain: 'modelessaisiese', right: 'read' },
        ncyBreadcrumb: {
            parent: 'modelessaisiese',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELES_SAISIES_LIST" | translate}}'
        },
        navigation: {
            menu: 'environnement_theme_mes',
            translate: 'MODELES_SAISIES.BREADCRUMBS.MODELES_SAISIES_LIST',
            order: 6
            //navigationCls: "menu-item-separator"
        },
        search: 'MODELES_SAISIES.BREADCRUMBS.MODELES_SAISIES_LIST'
    });

    $stateProvider.state('modelessaisiese.list.detail', {
        url: '/{id}',
        template: '<modele-saisie-detail></modele-saisie-detail>',
        rights: { domain: 'modelessaisiese', right: 'read' },
        ncyBreadcrumb: {
            parent: 'modelessaisiese.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('modelessaisiese.new', {
        url: '/new',
        template: '<modele-saisie-form></modele-saisie-form>',
        rights: { domain: 'modelessaisiese', right: 'create' },
        ncyBreadcrumb: {
            parent: 'modelessaisiese.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_NEW" | translate}}'
        },
        search: 'MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_NEW'
    });

    $stateProvider.state('modelessaisiese.edit', {
        url: '/{id}/edit',
        template: '<modele-saisie-form></modele-saisie-form>',
        rights: { domain: 'modelessaisiese', right: 'update' },
        ncyBreadcrumb: {
            parent: 'modelessaisiese.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('modelessaisiese.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'modelessaisiese.new' },
        ncyBreadcrumb: {
            parent: 'modelessaisiese.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('modelessaisiese.duplicate', {
        url: '/{id}/duplicate',
        template: '<modele-saisie-form></modele-saisie-form>',
        rights: { domain: 'modelessaisiese', right: 'create' },
        ncyBreadcrumb: {
            parent: 'modelessaisiese.list',
            label: '{{ "MODELES_SAISIES.BREADCRUMBS.MODELE_SAISIE_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
